<template>
	<div id="overlay" @click.self="$emit('close')">
		<div id="modalcont" class="item_detail_text">
			<!-- タイトル -->
			<div class="item_title flex reflex">
				<!-- 受付状態 -->
				<div class="item_status">
					<span v-if="(item.jyokyo_code !== 1)" class="mosikomi_imp">申込停止</span>
					<span v-else-if="(new Date(item.kikan_to)) < TODAY" class="mosikomi_imp">申込不可</span>
					<span v-else class="mosikomi_poss">受付中</span>
				</div>
				<!-- 施設名 -->
				<div class="item_sisetuname">
					<span>{{item.sisetu_name}}</span>
				</div>
			</div>		
			<!-- <p class="detail_title">【活動内容】</p> -->
			<div class="scroll-detail">
				<div class="flex reflex status_box">
					<!-- 分野のアイコン表示仮 -->
					<ul class="bunya_list">
						<li v-if="item.katudo_bunya_id === 1" class="korei_icon">
							<span class="bunya_text">高齢者関係</span>
						</li>
						<li v-if="item.katudo_bunya_id === 2" class="syogai_icon">
							<span class="bunya_text">障がい児・者関係</span>
						</li>
						<li v-if="item.katudo_bunya_id === 3" class="jido_icon">
							<span class="bunya_text">児童関係</span>
						</li>
						<li v-if="item.katudo_bunya_id === 4" class="hoken_icon">
							<span class="bunya_text">保健・医療関係</span>
						</li>
						<li v-if="item.katudo_bunya_id === 5" class="sonota_icon">
							<span class="bunya_text">その他</span>
						</li>
					</ul>
					<div>
						<span v-if="(item.gakusei === 1)" class="ukeire_tag_g">学生ポイント制度対象</span>
						<span v-else class="ukeire_tag_g _false">学生ポイント制度対象</span>
						<span v-if="(item.supporter_check === 1)" class="ukeire_tag">地域福祉サポーター対象</span>
						<span v-else class="ukeire_tag _false">地域福祉サポーター対象</span>
					</div>
				</div>
				<dl class="inner">
					<dt class="detail_title">内容</dt>
					<dd class="detail_content kaigyo">
						{{item.naiyou}}
					</dd>
					<!-- <dt class="detail_title" v-if="item.henkonaiyo">変更内容</dt> -->
					<dd class="detail_content kaigyo henko" v-if="item.henkonaiyo">
						{{item.henkonaiyo}}
					</dd>
					<dt class="detail_title">活動期間・時間</dt>
							<dd class="detail_content">
								{{ From_kikan }} ～ {{ To_kikan }}
								<div class="flex item_box">
									<ul class="flex youbi">
										<li v-if="item.week1_check === 1"><span class="week">月</span></li>
										<li v-if="item.week2_check === 1"><span class="week">火</span></li>
										<li v-if="item.week3_check === 1"><span class="week">水</span></li>
										<li v-if="item.week4_check === 1"><span class="week">木</span></li>
										<li v-if="item.week5_check === 1"><span class="week">金</span></li>
										<li v-if="item.week6_check === 1"><span class="week">土</span></li>
										<li v-if="item.week7_check === 1"><span class="week">日</span></li>
										<li v-if="item.week1_check !== 1 && item.week2_check !== 1 && item.week3_check !== 1 && item.week4_check !==1 && item.week5_check !== 1 && item.week6_check !== 1 && item.week7_check !== 1">曜日にかかわらず</li>
									</ul>
									<span class="time_height">{{item.jikan_from}}～{{item.jikan_to}}</span>
								</div>
							</dd>
					<dt class="detail_title">活動場所</dt>
					<dd class="detail_content kaigyo">
						〒{{item.zipcode}}<br>{{ item.address }}<br><fa icon="phone" class="icon" />{{item.tel}}<br v-if="item.kotukikan">{{item.kotukikan}}
						<br>
						<a v-if="item.url" :href="item.url" class="btn_link btn_true btn_hp_map" target="_blank"><fa icon="home" class="icon" />HP</a>
						<a v-else class="btn_link btn_false btn_hp_map" target="_blank" disabled><fa icon="home" class="icon" />HP</a>
						<a v-if="item.map_url" :href="item.map_url" class="btn_link btn_true btn_hp_map" target="_blank"><fa icon="map-marked-alt" class="icon" />MAP</a>
						<a v-else class="btn_link btn_false btn_hp_map" target="_blank" disabled><fa icon="map-marked-alt" class="icon" />MAP</a>
					</dd>
					<dt class="detail_title">募集人員</dt>
					<dd class="detail_content" v-if="(item.jinin_code === 1)">
						性別を問わない&emsp;{{item.jinin_total}}名
					</dd>
					<dd class="detail_content" v-else>
						性別毎&emsp;男性：{{item.jinin_men}}名 女性：{{item.jinin_women}}名
					</dd>
					<dt class="detail_title">募集中ボランティア</dt>
					<dd class="detail_content">
						<ul class="flex ukeire_box detail_content">
							<li><span class="ukeire ukeire_syogaku" v-if="item.uke_syogaku_check === 1">小</span></li>
							<li><span class="ukeire ukeire_cyugaku" v-if="item.uke_cyugaku_check === 1">中</span></li>
							<li><span class="ukeire ukeire_koko" v-if="item.uke_koko_check === 1">高</span></li>
							<li><span class="ukeire ukeire_tansen" v-if="item.uke_tansen_check === 1">短</span></li>
							<li><span class="ukeire ukeire_daigaku" v-if="item.uke_daigaku_check === 1">大</span></li>
							<li><span class="ukeire ukeire_syuhu" v-if="item.uke_syuhu_check === 1">主</span></li>
							<li><span class="ukeire ukeire_kaisya" v-if="item.uke_kaisya_check === 1">会</span></li>
							<li><span class="ukeire ukeire_korei" v-if="item.uke_korei_check === 1">齢</span></li>
							<li><span class="ukeire ukeire_syogai" v-if="item.uke_syogai_check === 1">障</span></li>
						</ul>
					</dd>
					<dt v-if="item.kei_tyusya_check !== 0 || item.kei_syokuji_check !== 0 || item.kei_syokuji_teikyo_check !== 0 || item.kei_koutsu_check !== 0" class="detail_title">経費</dt>
					<dd class="detail_content">
						<ul v-if="item.kei_tyusya_check !== 0 || item.kei_syokuji_check !== 0 || item.kei_syokuji_teikyo_check !== 0 || item.kei_koutsu_check !== 0" class="flex keihi_box">
							<li v-if="item.kei_tyusya_check === 1">駐車場有</li>
							<li v-if="item.kei_syokuji_teikyo_check === 1">食事提供有</li>
							<li v-if="item.kei_syokuji_check === 1">食事代&ensp;{{item.kei_syokuji}}円</li>
							<li v-if="item.kei_koutsu_check === 1">交通費</li>
							<li v-if="item.kei_futan_check === 1">全額負担</li>
							<li v-if="item.kei_futan_check === 2">一部負担&ensp;{{item.kei_futan}}円</li>
						</ul>
					</dd>
					<dt class="detail_title" v-if="item.pr">活動先からのメッセージ</dt>
					<dd class="detail_content kaigyo" v-if="item.pr">
						{{item.pr}}
					</dd>
					<dt class="detail_title" v-if="item.tyuijiko">注意事項</dt>
					<dd class="detail_content kaigyo" v-if="item.tyuijiko">
						{{item.tyuijiko}}
					</dd>
				</dl>
			</div>
			<div class="modal_bottom">
				<p v-if="!(item.jyokyo_code === 1)" class="icon mosikomi_imp_text"><fa icon="ban" />この募集は現在申込を停止しています</p>
				<p v-else-if="((new Date(item.kikan_to)) <= TODAY)" class="icon mosikomi_imp_text"><fa icon="ban" />この募集は活動期間を過ぎています</p>
				<p v-else-if="!(login.sex)" class="icon mosikomi_warn"><fa icon="exclamation-triangle" />申込にはログインが必要です</p>
				<div class="flex justifycont-c center buttons">
					<button @click="$emit('close')" class="btn_cancel">戻る</button>
					<router-link v-if="(login.sex) && (item.jyokyo_code === 1) && ((new Date(item.kikan_to)) >= TODAY)" :to="{ name: 'KatudoMosikomi', params: { value: item.id }}">
						<button class="btn_on">申込手続きへ</button>
					</router-link>
					<router-link v-if="!(login.sex) && (item.jyokyo_code === 1) && ((new Date(item.kikan_to)) >= TODAY)" to="/login">
						<button class="btn_login">
							<fa icon="user" class="icon fa-user"></fa>&ensp;ログイン
						</button>
					</router-link>
					<router-link v-if="!(login.sex) && (item.jyokyo_code === 1) && ((new Date(item.kikan_to)) >= TODAY)" to="/katudo-touroku/first">
						<button class="btn_new">
							<fa icon="user-plus" class="icon fa-user-plus"></fa>新規登録
						</button>
					</router-link>
				</div>
			</div>
			<!-- <p>※その他<br>HP,MAP,TEL,...</p> -->
		</div>
	</div>
</template>

<script>
import { inject } from 'vue';
// import { format } from 'date-fns'
// import ja from 'date-fns/locale/ja'
export default {
    props: {
        item: Object,
		From_kikan: String,
		To_kikan: String,
    },
	setup() {
		const { login } = inject('loginstate');
		return {
			login,
			// 日付の書式
			// format,
			// ja,
		}
	},
	data() {
		const TODAY = new Date();
		return {
			TODAY,
		}
	},
	created() {
	},
	methods: {
	},
}
</script>

<style>
#overlay {
	/* モーダルウィンドウの背景の設定 */
	z-index: 99;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(46, 46, 46, 0.5);

	display: flex;
	align-items: center;
	justify-content: center;

}

#modalcont {
	z-index: 100;
	/* max-width: 85vw; */
	max-width: 50vw;
	max-height: 85vh;
	/* padding: 1em; */
	padding: 1em .5em;
	background: #fff;
	position: relative;
	border-radius: 5px;
}
#modalcont button {
	/* 一時的にコメントアウトさせてもらう */
	/* height: auto;
	width: auto; */
}
#modalcont .modal_bottom {
	/* position: absolute; */
	bottom: 5px;
	overflow: hidden;
}
/* モーダルウィンドウでのスクロール */
.scroll-detail {
	overflow-y: scroll;
	/* border: 1px solid #dfdfdf; */
	/* width: 100%; */
	/* height: 50%; */
	/* position: relative; */
	/* max-height: 40vh; */
	max-height: 60vh;
	border: 1px solid #dfdfdf;
    border-radius: 5px;
	margin: 10px 0 5px;
    padding: 5px;
}
@media (orientation: landscape) and (max-height: 600px) {
	.scroll-detail {
		max-height: 40vh;
	}
}
/* モーダルでのスクロールデザイン */
/* 色は仮 */
/* 一部で使えない？ */
.scroll-detail::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.scroll-detail::-webkit-scrollbar-thumb {
  background: #afebdb;
  border-radius: 5px;
}
/* Firefox用 */
.scroll-detail {
	scrollbar-color: #afebdb #fff;
	scrollbar-width: thin;
}

#modalcont .ukeire_box {
	/* margin: 8px 0; */
}
.ukeire_tag,
.ukeire_tag_g {
	margin-top: 0;
}
#modalcont .keihi_box{
	/* margin: 8px 0; */
}
.bunya_list {
	padding-top: 3px
}

@media screen and (max-width: 1024px) {
	#modalcont {
	max-width: 85vw;
	/* max-height: 50vh; */
}
}
@media screen and (max-width: 415px) {

.scroll-detail {
	max-height: 50vh;
}
}

</style>
